import React from 'react';
import { ModalID } from '@repo/ui/src/modules/UI';
import { useUI } from './useUI';

export const useUIListener = (id: ModalID, cb: (open: boolean) => void) => {
  const { addListener } = useUI();
  React.useEffect(() => addListener(id, cb), [id, cb]);
};
